import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@front/shared/util-environment';
import { Alert, AlertCreateResponse } from '../models/backend';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private http = inject(HttpClient);
  private environment = inject(ENVIRONMENT);
  readonly #BASE_URL = `${this.environment.cmsApiUrl}/alert`;

  getMyAlerts() {
    return this.http.get<Alert[]>(`${this.#BASE_URL}/my`);
  }

  createAlert(type: 'sell' | 'buy', price: number) {
    return this.http.post<AlertCreateResponse>(`${this.#BASE_URL}/new`, {
      type,
      price,
    });
  }

  removeAlert(alertId: number | string) {
    return this.http.delete(`${this.#BASE_URL}/remove/${alertId}`);
  }
}
